import React, { Component } from 'react';
import * as signalR from '@aspnet/signalr';
import './styles/App.scss';
import { UserTypes } from './models/UserTypes';
import AdminPanel from './components/AdminPanel';
import PlayerPanel from './components/PlayerPanel';

interface IState {
	name: string;
	type: UserTypes;
	loading: boolean;
	gameId: string;
}

interface IProps {
}

class App extends Component<IProps, IState> {

	private connection: signalR.HubConnection;

	constructor(props: any) {
		super(props);

		let url = "/hub";
		// dev url
		//url = 'http://localhost:5000/hub';

		// create a connection
		this.connection = new signalR.HubConnectionBuilder()
			.withUrl(url)
			.build();

		this.state = {
			name: '',
			type: UserTypes.None,
			loading: false,
			gameId: ''
		};

	}

	componentDidMount() {
		const name = Math.random().toString();
		
		// connect to hub
		this.connection.start()
			.catch(err => document.write(err));

		// bind connection events
		this.connection.on("gameCreated", this.onGameCreated);
	
		this.setState({ name });
	}

	joinGame() {
		const type = UserTypes.Player;

		this.setState({ type });
	}

	createGame() {
		const loading = true;
		this.setState({ loading });
		this.connection.send("createGame");
	}

	onGameCreated = (gameId: string) => {
		const loading = false;
		const type = UserTypes.Admin;
		this.setState({ loading, gameId, type });
	}

	renderContent() {
		const { type, gameId } = this.state;

		switch (type) {
			case UserTypes.None:
				return (
					<div>
						<p>Welcome to QuizPad!</p>
						<p><a className="App-button nice-button" onClick={() => this.joinGame()}>Join existing game</a></p>
						<p>or</p>
						<p><a className="App-button nice-button" onClick={() => this.createGame()}>Create a new game</a></p>
					</div>
				);
			case UserTypes.Player:
				return (
					<PlayerPanel app={this} connection={this.connection} />
				);
			case UserTypes.Admin:
				return (
					<AdminPanel app={this} connection={this.connection} gameId={gameId} />
				);
		}

		return "";
	}

	render() {

		const { loading, type } = this.state; 

		return (
			<div className="App">
				<header className="App-header">
				{
					loading ? (
						<div className="Loading">Loading...</div>
					) : ''
				}
				{
					this.renderContent()
				}
				</header>
			</div>
		);
	}
}

export default App;
